module.exports = __webpack_public_path__ + "images/FUSA_icons/059-placeholder-1.33a1e9bd18f14c2da4dbde1f7b7f07e4.svg";